// @ts-nocheck
// TODO: tighten types after migration
import * as React from "react";
import { createRoot } from "react-dom/client";

import routing from "./routing";
import "./utils/seoAuditConsole";
import { initAuthSync } from "./utils/auth";
import ErrorBoundary from "./components/ErrorBoundary";

initAuthSync();

const container = document.getElementById('root');

if (container) {
    const root = createRoot(container);
    root.render(
        <ErrorBoundary>
            { routing }
        </ErrorBoundary>
    );
} else {
    console.error("Root element not found!");
}